module.exports = __webpack_public_path__ + "img/ElipseT1.6dc48da6.svg";